module.exports = __webpack_public_path__ + "img/sayfa-cizgi-yesil-1.4e98a626.png";